import { EntityServiceName } from '../enums/enums';

export interface MapConfigProps {
    projectId: string;
    mapConfigType: EntityServiceName;
    presetId?: string;
    runId?: string;
    abortSignal: AbortSignal;
}

export const enum RoadInfrastructureEntityName {
    Road = 'replancity_RoadInfrastructureRoadName',
    RoadSegment = 'replancity_RoadInfrastructureSegment',
    District = 'replancity_RoadInfrastructureDistrict',
    DistrictImportForm = 'replancity_DistrictImportForm',
}

export const enum ScenarioEventsEntityName {
    PopulationEvent = 'replancity_PopulationEvents',
    NetworkEvent = 'replancity_NetworkEvents',
    TransitEvent = 'replancity_TransitEvents',
    EvEvent = 'replancity_ElectricEvents',
    EmissionEvent = 'replancity_EmissionEvents',
}

export type StopType = 'DYNAMIC' | 'FIXED';

export type RunTask = {
    task: {
        name: string;
        roadInfrastructurePreset?: {
            id: string;
        };
        publicTransitPreset?: {
            id: string;
        };
        maasPreset?: {
            id: string;
        };
        evPreset?: {
            id: string;
        };
        scenarioCasePreset?: {
            id: string;
        };
        populationPreset: {
            id: string;
        };
        config: {
            id: string;
        };
        quality: number;
        stopType: StopType;
        maxIteration: number;
        relaxationStartOnPercentage: number;
        project: {
            id: string;
        };
    };
};
